import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Alert, Box, Snackbar } from "@mui/material";
import { useAddControllerMutation } from "../../../../middleware/controllersApi";
import { useAction } from "../../../../hooks/actions";
import { WarningValidationForm } from "../../../components/Notifications";
import { PATHS } from "../../../../constants";
import Header from "./Header";
import Body from "./Body";
import "./styles/style.css";

const AddController = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setIsErrorSubmit, setIsSuccessSubmit } = useAction();

  const [uuid, setUuid] = useState(null);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
  const [isWarningValidation, setIsWarningValidation] = useState(false);
  const [isConnected, setIsConnected] = useState(true);

  const [addController, { isError: isErrorAdd, isLoading: isLoadingAdd, isSuccess: isSuccessAdd }] =
    useAddControllerMutation();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleCancel = () => {
    navigate(PATHS.CONTROLLERS);
  };

  const onSubmit = async (data) => {
    addController(data).then((result) => {
      if ("error" in result) {
        return;
      } else {
        setUuid(result?.data?.id);
        return;
      }
    });
  };

  const handleSnackbarClose = () => {
    setIsSnackbarOpen(false);
  };

  useEffect(() => {
    setIsErrorSubmit(isErrorAdd);
  }, [isErrorAdd]);

  useEffect(() => {
    setIsSuccessSubmit(isSuccessAdd);
  }, [isSuccessAdd]);

  const onError = () => {
    setIsWarningValidation(true);
  };

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      setIsWarningValidation(true);
    }
  }, [errors]);

  return (
    <Box className="add-controller-container">
      <Header
        uuid={uuid}
        isConnected={isConnected}
        isSubmitDisabled={isLoadingAdd || isSuccessAdd}
        setIsConnected={setIsConnected}
        setIsSnackbarOpen={setIsSnackbarOpen}
        handleCancel={handleCancel}
      />

      <Body
        uuid={uuid}
        errors={errors}
        control={control}
        onSubmit={onSubmit}
        handleSubmit={handleSubmit}
        onError={onError}
      />

      {isSnackbarOpen && (
        <Snackbar
          open={isSnackbarOpen}
          autoHideDuration={10000}
          onClose={handleSnackbarClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={isConnected ? "success" : "error"}
            sx={{ width: "100%", marginTop: "100px" }}
          >
            {isConnected ? t("notification:success_connection") : t("notification:error_connection")}
          </Alert>
        </Snackbar>
      )}

      {isWarningValidation && <WarningValidationForm isOpen={isWarningValidation} setIsOpen={setIsWarningValidation} />}
    </Box>
  );
};

export default AddController;
